import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Title } from './title.service';

@Component({
  selector: 'fl-title',
  template: '',
})
export class TitleComponent implements OnInit {
  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private router: Router,
    private titleService: Title,
  ) {}

  ngOnInit() {
    this.router.events.subscribe(event => {
      // reset to default title on navigation.
      if (event instanceof NavigationStart) {
        this.titleService.setDefaultTitle();
      }
    });
  }
}
